import * as vendorTypes from '../types/vendorTypes'

const initialState = {
  allCustomers: null,
  allCustomersOffline: null,
  totalCustomers: 0,
  vendorPurchase: {},
  vendorCampaign: null,
  mobilesOrIdsDistinct: [],
}

const vendorReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case vendorTypes.GET_ALL_CUSTOMERS:
      return {
        ...state,
        allCustomers: payload,
      }
    case vendorTypes.GET_ALL_CUSTOMERS_OFFLINE:
      return {
        ...state,
        allCustomersOffline: payload,
      }
    case vendorTypes.GET_DISTINCT_MOBILE_ID_FOR_CAMPAIGN:
      return {
        ...state,
        mobilesOrIdsDistinct: payload,
      }
    case vendorTypes.GET_TOTAL_CUSTOMERS:
      return {
        ...state,
        totalCustomers: payload,
      }
    case vendorTypes.GET_VENDOR_PURCHASES:
      return {
        ...state,
        vendorPurchase: payload,
      }
    case vendorTypes.GET_VENDOR_CAMPAIGNS:
      return {
        ...state,
        vendorCampaign: payload,
      }
    default:
      return state
  }
}

export default vendorReducer
